export default function CategoryPage() { return <h1>Página de Categoría</h1>; }